import { render, staticRenderFns } from "./VuiChoiGiaiTriList.vue?vue&type=template&id=39274ad9"
import script from "./VuiChoiGiaiTriList.vue?vue&type=script&lang=js"
export * from "./VuiChoiGiaiTriList.vue?vue&type=script&lang=js"
import style0 from "./VuiChoiGiaiTriList.vue?vue&type=style&index=0&id=39274ad9&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports